import * as React from "react";

export function NavSectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="px-3 pt-4 pb-1 font-mono text-[9.5px] uppercase tracking-[.12em] text-ink-500">
      {children}
    </div>
  );
}
